import { FormField } from '../interface/interface';

export const PITCH_FORM_STEPS = [
    {
        key: 'companyDetail',
        subTitle: 'Company Details',
        clickable: true
    },
    {
        key: 'email',
        subTitle: 'Email Verification'
    },
    {
        key: 'business',
        subTitle: 'Business Details'
    }
];
export const pitchFormBasicDetailsFields: FormField[] = [
    {
        label: 'Company Name *',
        type: 'text',
        name: 'companyName',
        required: true,
        disabled: false,
        placeholder: 'Enter Company Name',
        component: 'input',
        errorMessage: 'Company name'
    },
    {
        label: 'Website*',
        type: 'text',
        name: 'website',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter website',
        errorMessage: 'Website'
    },
    {
        label: 'Company Profile*',
        type: 'file',
        name: 'companyProfile',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Select file',
        errorMessage: 'Company profile'
    },
    {
        label: 'Annual Turnover in USD*',
        type: 'select',
        name: 'annualTurnover',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select annual turnover',
        errorMessage: 'Annual turnover'
    },
    {
        name: 'industry',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Industry *',
        required: true,
        placeholder: 'Select Industry',
        errorMessage: 'Industry'
    },
    {
        label: 'Other Business Sector*',
        name: 'otherBusinessSector',
        required: true,
        type: 'text',
        placeholder: 'Enter Other Business Sector',
        errorMessage: 'Other Business Sector',
        component: 'input'
    }
];
export const pitchFormPOCDetailsFields: FormField[] = [
    {
        label: 'Full Name*',
        type: 'text',
        name: 'contactName',
        required: true,
        disabled: false,
        placeholder: 'Enter full name',
        component: 'input',
        errorMessage: 'Full name'
    },
    {
        label: 'Designation*',
        type: 'text',
        name: 'contactDesignation',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter designation',
        errorMessage: 'Designation'
    },
    {
        label: 'Email * ',
        type: 'text',
        name: 'contactEmail',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter email',
        errorMessage: 'Email'
    },
    {
        label: 'Phone Number*',
        type: 'phone',
        name: 'phoneNumber',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter phone number',
        errorMessage: 'Phone number'
    }
];

export const pitchFormBusinessDetailsFields: FormField[] = [
    {
        label: 'Current international markets your company is operating in *',
        type: 'multiSelect',
        name: 'currentInternationalMarket',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select markets',
        errorMessage: 'Current international markets'
    },
    {
        label: 'Your preferred market entry channels *',
        type: 'multiSelect',
        name: 'marketEntryChannel',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select preferred market entry channels',
        errorMessage: 'Preferred market entry channels'
    },
    {
        label: 'Please specify any other market entry channel*',
        type: 'text',
        name: 'otherMarketEntryChannel',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter other market entry channel',
        errorMessage: 'Other market entry channel'
    },
    {
        label: 'Select your target markets*',
        type: 'multiSelect',
        name: 'targetMarkets',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select target markets',
        errorMessage: 'Target markets'
    },

    {
        label: 'Please attach any documents supporting your expansion request *',
        type: 'file',
        name: 'expansionDocument',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select documents',
        errorMessage: 'Expansion documents'
    },
    {
        label: 'Please provide more details on your expansion objectives and strategy in the selected markets*',
        type: 'text',
        disabled: false,
        required: true,
        name: 'expansionDetails',
        placeholder: 'Enter description',
        component: 'textarea' as 'textarea',
        errorMessage: 'Expansion details'
    }
];
